import { clsx } from 'clsx'
import { type FC } from 'react'

import { type StatusItemType } from './translations'

export const StatusItem: FC<{
  className?: string
  item: StatusItemType
}> = ({ item }: { item: StatusItemType }) => {
  const { classColor, description, title } = item

  return (
    <li
      className={clsx(
        'before:absolute before:left-0 before:top-3 before:rounded-full before:border-8 before:border-dark-brand-medium',
        'relative flex flex-col gap-1 p-2 pl-6',
        classColor === 'green' && 'before:border-dark-success',
        classColor === 'yellow' && 'before:border-dark-note',
        classColor === 'red' && 'before:border-dark-brand-medium',
      )}
    >
      <p
        className={clsx(
          'text-m font-medium',
          classColor === 'green' && 'text-dark-success',
          classColor === 'yellow' && 'text-dark-note',
          classColor === 'red' && 'text-dark-brand-medium',
        )}
      >
        {title}
      </p>
      <p className="text-s font-normal text-dark-primary-max">{description}</p>
    </li>
  )
}
